import classes from './BootSpinner.module.css';

// @ai-generated 2026-10-12T14:25:59+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
/** A spinner that needs no theme, for while the app cannot render its providers yet. */
export function BootSpinner() {
    return (
        <div className={classes.wrapper} role="status" aria-label="Wird geladen">
            <div className={classes.spinner} />
        </div>
    );
}
